import { render } from "./request-stepper-result.vue?vue&type=template&id=6484e482&scoped=true&ts=true"
import script from "./request-stepper-result.vue?vue&type=script&lang=ts"
export * from "./request-stepper-result.vue?vue&type=script&lang=ts"

import "./request-stepper-result.vue?vue&type=style&index=0&id=6484e482&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6484e482"]])

export default __exports__